import { render, staticRenderFns } from "./BuildFilterButtonsComp.vue?vue&type=template&id=d923ac78&scoped=true&"
import script from "./BuildFilterButtonsComp.vue?vue&type=script&lang=ts&"
export * from "./BuildFilterButtonsComp.vue?vue&type=script&lang=ts&"
import style0 from "./BuildFilterButtonsComp.vue?vue&type=style&index=0&id=d923ac78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d923ac78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VLayout})
